module.exports = __webpack_public_path__ + "static/media/dropdown.f2a846c2.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/icons/dropdown.svg
 ** module id = 2216
 ** module chunks = 50
 **/